/** @module csi/table/matrix/ColumnAssociationContainer */
define([
	"dojo/_base/declare",
	"underscore",
	"./Path"
], function(declare,_,PathMatrix) {

	return declare(PathMatrix, {

		/** @property {boolean} restrictQuery - currently do not have functionality to filter in column matrix */
		restrictQuery: true,

		/** @property {String} columnAssociation - association from path nodes to column node (required) */
		//columnAssociation: "",

		/** @property {String} columnPath - path to column nodes (required) */
		//columnPath: "",

		/**
		 * @override
		 * Filter out nodes along the columnPath based on those that reference the current column through the node’s columnAssociation reference container
		 */
		_filterNodes: function(ctx, spec, nodes) {
			var columnUrl = spec.columnUrl;
			var id = this.columnAssociation;

			return _.filter(nodes, function(node) {
				return _.contains(node[id], columnUrl);
			});
		}
	});
});